import { FormFieldTypes } from "../../../../../../components/finalForms/libs/data/formFieldType";

const initState = {
  dtDateEffective: null,
  dtDateTermination: null,
  dtOriginalTerminationDate: null,
  lContractTypeKey: null,
  lInstallmentTypeID: null,
  bServicePlan: false,
  lServicePlanTermKey: null,
  bManualSchedule: false,
  bTaxExempt: false,
  bShowConsumptionOnPortal: false,
  bCostsPerDepartment: false,
  bUnlimitedProducts: false,
  bSharedRisk: false,
  dtSharedRiskStartDate: null,
  dblAmtTotal: "",
  dblContractDepartmentTotal: "",
  dblContractBillScheduleToatl: "",
  sRenewedContract: "",
  nSharedRiskPercentage: null,
  sPurchaseOrder: "",
  lSalesRepKey: null,
  dblAmtInvoiced: "",
  lSalesTaxKey: null,
  SalesTaxKey: null,
  lPaymentTermsKey: null,
};

export const pendingSpecificationsConfig = {
  name: "Specifications",
  initialState: initState,
  section: [
    {
      sectionId: "specificationsSection",
      title: "Specifications Details",
      row: {},
      style: {
        sectionStyle: "col-lg-6 col-md-6 pr-5",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      rowGroup: [
        {
          groupLabel: "Specifications Information", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: (
            <div className="form-card row pending-contract-form"></div>
          ),
          fields: [
            {
              id: "lContractTypeKey",
              label: "Contract Type :",
              Field_Name: "Contract Type",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lContractTypeKey",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Select Contract Type",
                options: [],
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "lSalesRepKey",
              label: "Sales Rep:",
              Field_Name: "Sales Rep",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lSalesRepKey",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Select Sales Rep",
                options: [],
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "dblAmtTotal",
              label: "Contract Total : ",
              Field_Name: "Contract Total",
              fieldType: FormFieldTypes.INPUT,
              dataField: "dblAmtTotal",
              fieldSetting: {
                placeholder: "Enter Contract Total",
                allowSpace: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "dtContractTermMonth",
              label: "Contract Term Month :",
              Field_Name: "Contract Term Month",
              fieldType: FormFieldTypes.NUMERIC,
              dataField: "dtContractTermMonth",
              fieldSetting: {
                placeholder: "Select Contract Term Month",
                allowSpace: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "lPendingContractAgreementTemplateKey",
              label: "Agreement Template:",
              Field_Name: "Agreement Template",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lPendingContractAgreementTemplateKey",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Select Agreement Template",
                options: [],
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-8 col-md-8 col-12 mb-2 ",
              },
            },
            {
              id: "shortVersionOfScope",
              label: "Short version of scope",
              Field_Name: "Short version of scope",
              fieldType: FormFieldTypes.CHECKBOX,
              dataField: "shortVersionOfScope",
              fieldSetting: {
                placeholder: "  ",
                hasMainTitle: "Short version of scope :",
              },
              style: {
                containerCss:
                  "col-xxl-4 col-xl-4 col-lg-4 col-12 mb-2 double-label-sec mt-2",
              },
            },
            {
              id: "dtDateEffective",
              label: "Effective Date :",
              Field_Name: "Effective Date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "dtDateEffective",
              fieldSetting: {
                placeholder: "Select Effective Date",
                allowSpace: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2",
              },
            },
            {
              id: "status",
              label: "Status :",
              Field_Name: "Status",
              fieldType: FormFieldTypes.SELECT,
              dataField: "status",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Select Status",
                options: [
                  { label: "Pending", value: "Pending" },
                  { label: "Dead", value: "Dead" }
                ],
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12",
              },
            },
          ],
        },
      ],
    },
    {
      sectionId: "specificationsSection1",
      title: "Specifications Details",
      row: {},
      style: {
        sectionStyle: "col-lg-6 col-md-6 pr-5",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      rowGroup: [
        {
          groupLabel: "Specifications Information", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: <div className="form-card row"></div>,
          fields: [
            {
              id: "sShipAddr1",
              label: "Address Line 1 :",
              Field_Name: "Address Line 1",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sShipAddr1",
              fieldSetting: {
                placeholder: "Enter Address Line 1",
              },
              style: {
                containerCss: "col-12 mb-2",
              },
            },
            {
              id: "sShipAddr2",
              label: "Address Line 2 :",
              Field_Name: "Address Line 2",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sShipAddr2",
              fieldSetting: {
                placeholder: "Enter Address Line 2",
              },
              style: {
                containerCss: "col-12 mb-2",
              },
            },
            {
              id: "sShipZip",
              label: "Zip/City/State :",
              Field_Name: "Zip",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sShipZip",
              fieldSetting: {
                placeholder: "Enter Zip",
                isEnableOnChange: true,
                isLoading: false,
              },
              style: {
                containerCss: "col-xxl-4 col-lg-5 mb-2 pr-0",
              },
            },
            {
              id: "sShipCity",
              label: "",
              Field_Name: "City",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sShipCity",
              fieldSetting: {
                placeholder: "Enter City",
              },
              style: {
                containerCss: "col-xxl-5 col-lg-4 mb-2 pr-0 validation-left-0",
              },
            },
            {
              id: "sShipState",
              label: "",
              Field_Name: "State",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sShipState",
              fieldSetting: {
                placeholder: "Select State",
                options: [],
                isLoading: false,
              },
              style: {
                containerCss: "col-xxl-3 col-lg-3 mb-2 validation-left-0",
              },
            },
            {
              id: "dblAmtInvoiced",
              label: "Voice :",
              Field_Name: "voice",
              fieldType: FormFieldTypes.INPUT,
              dataField: "dblAmtInvoiced",
              fieldSetting: {
                placeholder: "Enter Voice",
                allowSpace: true,
              },
              style: {
                containerCss: "col-lg-7 col-md-7 col-12 mb-2",
              },
            },
            {
              id: "sContractFaxNumber",
              label: "Fax :",
              Field_Name: "Fax :",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sContractFaxNumber",
              fieldSetting: {
                placeholder: "Enter Fax",
                allowSpace: true,
              },
              style: {
                containerCss: "col-lg-7 col-md-7 col-12 mb-2",
              },
            },
          ],
        },
      ],
    },
  ],
};
